<template>
    <div v-if="!isLoading" class="flex flex-col space-y-10 mt-6 pb-16">
        <ProfileDetailCard />
        <BasicInfoDetailCard />
        <CurriculumnDetailCard />
        <AddressDetailCard />
        <ExperienceDetailCard />
        <FormationDetailCard />
        <LanguageDetailCard />
        <SkillsDetailCard />
        <PresentationDetailCard />
        <ProfessionalProfileCard />
    </div>
</template>

<script>
import ProfileDetailCard from '../../components/dashboard/profile-detail/ProfileDetailCard.vue';
import BasicInfoDetailCard from '../../components/dashboard/profile-detail/BasicInfoDetailCard.vue';
import CurriculumnDetailCard from '../../components/dashboard/profile-detail/CurriculumnDetailCard.vue';
import AddressDetailCard from '../../components/dashboard/profile-detail/AddressDetailCard.vue';
import ExperienceDetailCard from '../../components/dashboard/profile-detail/ExperienceDetailCard.vue';
import FormationDetailCard from '../../components/dashboard/profile-detail/FormationDetailCard.vue';
import LanguageDetailCard from '../../components/dashboard/profile-detail/LanguageDetailCard.vue';
import SkillsDetailCard from '../../components/dashboard/profile-detail/SkillsDetailCard.vue';
import ProfessionalProfileCard from '../../components/dashboard/profile-detail/ProfessionalProfileCard.vue';
import PresentationDetailCard from '../../components/dashboard/profile-detail/PresentationDetailCard.vue';

export default {
    created() {
        this.googleAnalytics()
        this.$store.dispatch('presentation/fetch')
    },

    data() {
        return {
            isLoading: false
        }
    },

    methods: {
        googleAnalytics() {
            const { company_label } = this.$router.history.current.params
            this.$ga.page(`${company_label}/profile/detail`)
        },
    },

    components: {
        ProfileDetailCard,
        BasicInfoDetailCard,
        AddressDetailCard,
        ExperienceDetailCard,
        CurriculumnDetailCard,
        FormationDetailCard,
        LanguageDetailCard,
        SkillsDetailCard,
        ProfessionalProfileCard,
        PresentationDetailCard
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
